// This is the parent component of a modal: ModalProfileinfoone

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useState } from "react";
import GeneralSettings from "./GeneralSettings";
import Profileeditone from "./Profileeditone";
import Profilepasswordone from "./Profilepasswordone";
import { formatDate } from "./utils";
import IndustrySectors from "./IndustrySectors";

export default function Profileinfoone() {
  const [activeItem, setActiveItem] = useState("sectors");

  const vendor = JSON.parse(localStorage.getItem("vendor"));
  const user = JSON.parse(localStorage.getItem("user"));

  const handleItemClick = (itemId) => {
    setActiveItem(itemId);
  };

  const renderContent = () => {
    if (!vendor) {
      return <LoadingMessage>Loading vendor details...</LoadingMessage>;
    }
    switch (activeItem) {
      case "general":
        return <GeneralSettings vendor={vendor} />;
      case "sectors":
        return <IndustrySectors vendor={vendor} />;
      // case "edit-picture":
      //   return <Profileeditone vendor={vendor} setActiveItem={setActiveItem} />;
      case "password":
        return <Profilepasswordone setActiveItem={setActiveItem} />;
      default:
        return <LoadingMessage>Select a setting</LoadingMessage>;
    }
  };

  return (
    <RootWrapperProfileinfoone>
      <Dashboard>
        <Wrapper>
          <Frame1503>
            <Frame1497>
              <ProfileImage
                src={
                  vendor?.user?.profile_picture ||
                  "https://via.placeholder.com/103"
                }
                alt="Profile"
                onError={(e) => {
                  e.target.src = "https://via.placeholder.com/103";
                }}
              />
            </Frame1497>
            <Frame1494>
              <Nesti>{vendor?.company_name}</Nesti>
              <Vendor>Vendor</Vendor>
              <MemberSince01Mar2025>
                Vendor Since: {formatDate(vendor?.user?.created_at)}
              </MemberSince01Mar2025>
            </Frame1494>
          </Frame1503>
          <Frame1502>
            <PRTNR.SidebarNav
              activeItem={activeItem}
              onItemClick={handleItemClick}
            />
            <Frame1501>{renderContent()}</Frame1501>
          </Frame1502>
        </Wrapper>
      </Dashboard>
    </RootWrapperProfileinfoone>
  );
}

const Frame1501 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
  gap: 21px;
  width: 886px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const RootWrapperProfileinfoone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding-inline: clamp(16px, 2.5vw, 60px);
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  box-sizing: border-box;
  padding: 60px 0px;
  flex-shrink: 0;
  width: 100%;
  max-width: 1200px;
  @media (max-width: 640px) {
    padding: 32px 0px;
  }
`;

const Frame1503 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 31px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

const Frame1497 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  border-radius: 200px;
  width: clamp(80px, 10vw, 103px);
  height: clamp(80px, 10vw, 103px);
  background: rgb(255, 255, 255);
  box-sizing: border-box;
  overflow: hidden;
  flex-shrink: 0;
`;

const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 32px;
`;

const LoadingMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: rgb(100, 116, 139);
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
`;

const Frame1494 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  box-sizing: border-box;
  min-width: 0;
`;

const Nesti = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(20px, 4vw, 30px);
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  word-break: break-word;
`;

const Vendor = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2.5vw, 18px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const MemberSince01Mar2025 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2.5vw, 18px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1502 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;
